import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './Checkmykyc.scss'
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";

import contactusimg from '../../assets/images/contact-us-img.jpg';

import businessAPI from '../../assets/images/businessAPI.jpg';
import financialCheckAPI from '../../assets/images/financialCheckAPI.webp';
import kYCVerificationAPI from '../../assets/images/kYCVerificationAPI.webp';
import professionCheck from '../../assets/images/professionCheck.jpg';
import vehicleVerification from '../../assets/images/vehicleVerification.jpg';

import heroimage from '../../assets/images/hero-img.png';
import playIcon from '../../assets/images/icon-play.svg';

import feature from "../../assets/images/onboard/onboard3.webp";
import feature1 from "../../assets/images/onboard/onboard1.webp";
import feature2 from "../../assets/images/solution/solution3.webp";
import feature3 from "../../assets/images/solution/solution2.webp";
import feature4 from "../../assets/images/solution/solution1.webp";
import feature5 from "../../assets/images/solution/solution.webp";

function Apiplateform() {
  const texts = ["Identity Verification API Platform"];
  const [textIndex, setTextIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);


  const products = [
    {
      id: 1,
      title: "Profession Check",
      description: "Input the Person’s Details, such as name, ID, or contact info, into a profession verification tool.",
      image: professionCheck,
      link: "#",
    },
    {
      id: 2,
      title: "Vehicle Verification",
      description: "Enter the Vehicle Details, such as the registration number, into a verification portal or app.",
      image: vehicleVerification,
      link: "#",
    },
    {
      id: 3,
      title: "KYC Verification API",
      description: "The customer is asked to provide personal information such as their full name, address, date of birth, and a government-issued ID (e.g., passport, driver's license).",
      image: kYCVerificationAPI,
      link: "#",
    },
    {
      id: 4,
      title: "Business API",
      description: "A Business API acts as a digital bridge, connecting different software systems to work together smoothly.",
      image: businessAPI,
      link: "#",
    },
    {
      id: 5,
      title: "Financial Check API",
      description: "Send a Request with customer or company financial data to the API endpoint.",
      image: financialCheckAPI,
      link: "#",
    },
  ];

  const titleLines = [
    "Securing",
    "digital",
    "identities"
  ];


  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { fname, lname, phone, email, message } = formData;

    // Validation: prevent empty submit
    if (!fname || !lname || !phone || !email || !message) {
      alert("Please fill all fields before submitting!");
      return;
    }

    alert("Form Submitted Successfully!");
    navigate("/");
  };


  // Helper component for animated text lines
  const AnimatedTextLine = ({ text }) => (
    <div className="split-line" style={{
      display: "block",
      textAlign: "start",
      position: "relative"
    }}>
      <span>
        {text.split('').map((char, index) => (
          <AnimatedCharacter key={index} char={char} />
        ))}
      </span>
    </div>
  );

  // Helper component for animated characters
  const AnimatedCharacter = ({ char }) => (
    <div style={{
      position: "relative",
      display: "inline-block",
      opacity: 1,
      visibility: "inherit",
      transform: "translate(0px, 0px)"
    }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <div style={{
          position: "relative",
          display: "inline-block",
          transform: "translate(0px, 0px)",
          opacity: 1
        }}>
          {char}
        </div>
      </div>
    </div>
  );

  const ProductCard = ({ product }) => {
    return (
      <a href='#' rel="noopener noreferrer" className="product-card">
        <div className="product-image">
          <img
            src={product.image}
            alt={product.title}
            width="200"
            height="auto"
          />
        </div>
        <div className="product-text">
          <h3>{product.title}</h3>
          {/* <p>{product.description}</p> */}
        </div>
      </a>
    );
  };
  return (
    <><div className="hero">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="hero-content">
              <div className="section-title dark-section">
                <h3 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                  welcome to secure compliance
                </h3>
                <h1 className="text-anime-style-2" data-cursor="-opaque" style={{ perspective: 400 }}>
                  {titleLines.map((line, index) => (
                    <AnimatedTextLine key={index} text={line} />
                  ))}
                </h1>
                <p
                  className="wow fadeInUp"
                  data-wow-delay="0.2s"
                  style={{
                    visibility: "visible",
                    animationDelay: "0.2s",
                    animationName: "fadeInUp"
                  }}
                >
                  Guiding you with expert compliance insights and strategic security solutions to achieve regulatory alignment, fraud prevention, and long-term trust
                </p>
              </div>

              <div
                className="hero-content-body wow fadeInUp"
                data-wow-delay="0.4s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.4s",
                  animationName: "fadeInUp"
                }}
              >
                <div className="hero-btn">
                  <a href="/contact" className="btn-default">
                    get started
                  </a>
                </div>

                <div className="hero-introduction-video">
                  <div className="video-play-button">
                    <a
                      href="#"
                      className="popup-video"
                      data-cursor-text="Play"
                    >
                      <img src={playIcon} alt="Play introduction video" />
                    </a>
                    <p>introduction</p>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div className="col-lg-6">
            <div className="hero-image">
              <div className="hero-img">
                <figure>
                  <img src={heroimage} alt="Financial consulting services" />
                </figure>
              </div>

              <div className="company-experience">
                <h3>
                  <span className="counter">5</span>+
                </h3>
                <p>Years of experience in KYC/AML</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <div className="checkmykyc_new">


        <div className="product-section">
          <Container>
            <Row>
              <h2>API Platforms</h2>
              <div className="row gy-4">
                {products.map((product) => (
                  <Col md={4} xs={12}>
                    <ProductCard key={product.id} product={product} />
                  </Col>
                ))}
              </div>

              {/* <div className="see_more">
              <Link to={"#"} className="btn btn-primary">
                See More
              </Link>
            </div> */}
            </Row>
          </Container>
        </div>
        <div className="auth-section Benefits">
          <Container>
            <Row>
              <Col md={12}>
                <h5 className="platform-title">
                  Drive Business Growth with Digital Onboarding
                </h5>
                <h2 className="main-title">
                  Unlock the Benefits of Seamless Identity Verification!
                </h2>
              </Col>
              <Col md={12}>
                <div className="features">
                  <Row>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature} alt="Feature" />
                            </div>{" "}
                            Enhance UX with a real-time ID Verification
                          </h3>
                          <p>
                            Retire lengthy form filling-based KYC and adopt
                            low-touch, intuitive, and tech-driven onboarding models.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature1} alt="Feature" />
                            </div>{" "}
                            Streamline the User Onboarding Process
                          </h3>
                          <p>
                            Automated eKYC eliminates human intervention, thereby
                            reducing the cost, effort, and time spent on onboarding.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature2} alt="Feature" />
                            </div>{" "}
                            Mitigate Financial Crime & Identity Theft
                          </h3>
                          <p>
                            Get instant alerts on suspicious activities with
                            AI-driven identity verification and advanced AML
                            screening.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature3} alt="Feature" />
                            </div>{" "}
                            Ensure KYC & AML Verification Compliance
                          </h3>
                          <p>
                            Prevent, detect, and report money laundering activities
                            on your digital platform accurately and in real-time
                            using AI-based Risk Assessment achieved by screening
                            from global watchlists.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature4} alt="Feature" />
                            </div>
                            Quickly Integrate Solutions with REST API
                          </h3>
                          <p>
                            Integrate Identity verification APIs with your existing
                            workflows and enable secure digital onboarding on your
                            platform with accurate OCR-based ID checks.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md={4} sm={12}>
                      <div className="feature">
                        <div className="content">
                          <h3>
                            <div className="sixFeature">
                              <img src={feature5} alt="Feature" />
                            </div>{" "}
                            Detect and Prevent Fraud on Digital Platforms
                          </h3>
                          <p>
                            Use up-to-date global watchlists and PEP analytics
                            databases to verify and cross-match users to be screened
                            for financial crime and identity-proofing.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
      <div className="contact-form-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">

              <div className="contact-form-img">
                <figure className="image-anime reveal">
                  <img src={contactusimg} alt="contactusimg" />
                </figure>
              </div>

            </div>
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">contact us</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Get in Touch <span>with Us</span>
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.2s">
                  Have questions or need assistance? Reach out to us today! We're
                  here to provide expert solutions and friendly support.
                </p>
              </div>
              {/* Section Title End */}
              <div className="contact-form">
                {/* Contact Form Start */}
                 <form
      id="contactForm"
      action="#"
      method="POST"
      className="wow fadeInUp"
      data-wow-delay="0.4s"
      onSubmit={handleSubmit}
    >
      <div className="row">

        <div className="form-group col-md-6 mb-4">
          <input
            type="text"
            name="fname"
            className="form-control"
            placeholder="First name"
            value={formData.fname}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group col-md-6 mb-4">
          <input
            type="text"
            name="lname"
            className="form-control"
            placeholder="Last name"
            value={formData.lname}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group col-md-6 mb-4">
          <input
            type="text"
            name="phone"
            className="form-control"
            placeholder="Phone no"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group col-md-6 mb-4">
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="E-mail address"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group col-md-12 mb-5">
          <textarea
            name="message"
            className="form-control"
            rows={4}
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-12">
          <button type="submit" className="btn-default">
            send message
          </button>
        </div>

      </div>
    </form>
                {/* Contact Form End */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Apiplateform;
